"use client";
import React from "react";
import { FaArrowRight } from "react-icons/fa";
import { useDict } from "@/components/providers/LocaleProvider";
import { TransitionLink } from "@/components/shared/TransitionLink";

const CtaSection = () => {
  const t = useDict();
  return (
    <section className="py-20 lg:py-32 bg-gradient-to-br from-primary/5 to-accent/5">
      <div className="max-w-4xl mx-auto px-6 text-center space-y-8">
        <h2 className="font-bold text-4xl md:text-5xl lg:text-6xl text-foreground">
          {t.servicesPage.cta.title}
        </h2>
        <p className=" text-xl text-muted-foreground max-w-2xl mx-auto">
          {t.servicesPage.cta.description}
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <TransitionLink
            href="/book-a-meeting"
            className="inline-flex items-center justify-center  font-semibold text-lg px-8 py-3 rounded-full hover:scale-105 transition-all duration-300 bg-primary text-primary-foreground"
          >
            {t.servicesPage.cta.button}
            <FaArrowRight className="ml-2 h-5 w-5" />
          </TransitionLink>
        </div>
      </div>
    </section>
  );
};

export default CtaSection;
